var map = {
	"./Covid/product.png": "7e71",
	"./Financely/product.png": "a048",
	"./Linkedin/product.png": "58af",
	"./QRPay/product.png": "2bcc",
	"./Rabbit/product.png": "1677",
	"./Watchlist/product.png": "65c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c004";